/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RobotTypeEnum = 'GENERIC' | 'RI20_FANUC' | 'RI20_KUKA' | 'RC10_UR' | 'RC12' | 'RC20' | 'CUSTOM_SOLUTION';

export const RobotTypeEnum = {
    GENERIC: 'GENERIC' as RobotTypeEnum,
    RI20_FANUC: 'RI20_FANUC' as RobotTypeEnum,
    RI20_KUKA: 'RI20_KUKA' as RobotTypeEnum,
    RC10_UR: 'RC10_UR' as RobotTypeEnum,
    RC12: 'RC12' as RobotTypeEnum,
    RC20: 'RC20' as RobotTypeEnum,
    CUSTOM_SOLUTION: 'CUSTOM_SOLUTION' as RobotTypeEnum
};

